import React from 'react';
import { Phone, Mail, ChevronRight } from 'lucide-react';
const FAQS = [{
  question: 'How Long Until My Switchplates Arrive?',
  answer: <>
        You can expect your switchplates to arrive within two weeks. Since it is
        impossible to stock every size and individual configuration for over a
        thousand designs most of our orders are made as they are received. If
        you have placed a{' '}
        <a href="#/custom-orders" className="text-gold hover:text-gold-dark font-bold underline underline-offset-4 transition-colors" data-id="element-401">
          Special Order
        </a>
        , or a design that is not currently in stock, it may take a few more
        days for us to make the switchplate for you. All of our switchplates are
        made right here in West Virginia.
      </>
}, {
  question: 'How Much for Shipping and Handling?',
  answer: <>
        We ship UPS or regular mail, determined by destination and the size of
        the package. Please see our{' '}
        <a href="#/shipping" className="text-gold hover:text-gold-dark font-bold underline underline-offset-4 transition-colors" data-id="element-402">
          Shipping Information
        </a>{' '}
        page for complete shipping information.
      </>
}, {
  question: 'How Do I Make an Exchange or Return Something?',
  answer: <>
        Returns or exchanges are accepted for up to 30 days, excluding custom or
        special orders, providing the switchplates are still packaged and have
        not been mounted on the wall. All returns must have a Return
        Authorization Number for tracking purposes. Please see the{' '}
        <a href="#/returns" className="text-gold hover:text-gold-dark font-bold underline underline-offset-4 transition-colors" data-id="element-403">
          Returns or Exchanges
        </a>{' '}
        page for complete details on returning items to us.
      </>
}];
export function FAQPage() {
  return <section className="bg-cream" data-id="element-404">
      {/* Page Header */}
      <div className="bg-cream-dark border-b border-warmBorder" data-id="element-405">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10 md:py-14" data-id="element-406">
          <nav className="flex items-center gap-2 text-sm text-warmGray mb-4" data-id="element-407">
            <a href="#/" className="hover:text-gold transition-colors" data-id="element-408">
              Home
            </a>
            <ChevronRight size={14} className="text-warmGray/50" data-id="element-409" />
            <span className="text-charcoal font-medium" data-id="element-410">
              FAQ &amp; "How To" Info
            </span>
          </nav>
          <h1 className="text-3xl md:text-4xl font-serif text-charcoal" data-id="element-411">
            FAQ &amp; "How To" Info
          </h1>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-16" data-id="element-412">
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-16" data-id="element-413">
          {/* Main FAQ Content */}
          <div className="lg:w-2/3" data-id="element-414">
            <div className="space-y-6" data-id="element-415">
              {FAQS.map((faq, idx) => <div key={idx} className="bg-white p-8 md:p-10 rounded-sm shadow-sm border border-warmBorder" data-id="element-416">
                  <h2 className="text-xl md:text-2xl font-serif text-charcoal mb-4" data-id="element-417">
                    {faq.question}
                  </h2>
                  <p className="text-warmGray leading-relaxed text-base md:text-lg" data-id="element-418">
                    {faq.answer}
                  </p>
                </div>)}
            </div>

            {/* Contact CTA */}
            <div className="mt-12 bg-charcoal text-cream p-8 md:p-10 rounded-sm" data-id="element-419">
              <h3 className="text-2xl font-serif text-white mb-3" data-id="element-420">
                Still Have Questions?
              </h3>
              <p className="text-warmGray-light leading-relaxed mb-6" data-id="element-421">
                Our customer service team is happy to help you find the right
                switchplates, figure out sizing, or answer any other questions.
              </p>
              <div className="flex flex-col sm:flex-row gap-4" data-id="element-422">
                <a href="tel:8004976946" className="inline-flex items-center gap-2 px-6 py-3 bg-gold hover:bg-gold-light text-white font-bold rounded-sm transition-colors text-sm" data-id="element-423">
                  <Phone size={16} data-id="element-424" />
                  800.497.6946
                </a>
                <a href="mailto:switchplategallery@msn.com" className="inline-flex items-center gap-2 px-6 py-3 bg-white/10 border border-white/20 text-white hover:bg-white/20 font-bold rounded-sm transition-colors text-sm" data-id="element-425">
                  <Mail size={16} data-id="element-426" />
                  switchplategallery@msn.com
                </a>
              </div>
              <p className="text-warmGray-light text-sm mt-4" data-id="element-427">
                Available 9AM–5PM EST
              </p>
            </div>
          </div>

          {/* Sidebar */}
          <div className="lg:w-1/3" data-id="element-428">
            <div className="bg-white p-8 rounded-sm border border-warmBorder sticky top-32 shadow-warm" data-id="element-429">
              <h4 className="font-serif text-xl text-charcoal mb-6 border-b border-warmBorder pb-4" data-id="element-430">
                Helpful Links
              </h4>
              <ul className="space-y-4" data-id="element-431">
                <li data-id="element-432">
                  <a href="#/size-chart" className="flex items-center text-warmGray hover:text-gold transition-colors font-medium group" data-id="element-433">
                    <span className="w-2 h-2 rounded-full bg-gold/50 mr-3 group-hover:bg-gold transition-colors" data-id="element-434"></span>
                    Size Chart &amp; Measuring Guide
                  </a>
                </li>
                <li data-id="element-435">
                  <a href="#/shipping" className="flex items-center text-warmGray hover:text-gold transition-colors font-medium group" data-id="element-436">
                    <span className="w-2 h-2 rounded-full bg-gold/50 mr-3 group-hover:bg-gold transition-colors" data-id="element-437"></span>
                    Shipping Information
                  </a>
                </li>
                <li data-id="element-438">
                  <a href="#/returns" className="flex items-center text-warmGray hover:text-gold transition-colors font-medium group" data-id="element-439">
                    <span className="w-2 h-2 rounded-full bg-gold/50 mr-3 group-hover:bg-gold transition-colors" data-id="element-440"></span>
                    Returns &amp; Exchanges
                  </a>
                </li>
                <li data-id="element-441">
                  <a href="#/custom-orders" className="flex items-center text-warmGray hover:text-gold transition-colors font-medium group" data-id="element-442">
                    <span className="w-2 h-2 rounded-full bg-gold/50 mr-3 group-hover:bg-gold transition-colors" data-id="element-443"></span>
                    Custom &amp; Special Orders
                  </a>
                </li>
                <li data-id="element-444">
                  <a href="#/contact" className="flex items-center text-warmGray hover:text-gold transition-colors font-medium group" data-id="element-445">
                    <span className="w-2 h-2 rounded-full bg-gold/50 mr-3 group-hover:bg-gold transition-colors" data-id="element-446"></span>
                    Contact Us
                  </a>
                </li>
              </ul>

              <div className="mt-8 pt-6 border-t border-warmBorder" data-id="element-447">
                <p className="text-sm text-warmGray mb-2 uppercase tracking-wider font-bold" data-id="element-448">
                  Need sizing help?
                </p>
                <a href="tel:8004976946" className="text-2xl font-serif text-gold hover:text-gold-dark transition-colors" data-id="element-449">
                  800.497.6946
                </a>
                <p className="text-xs text-warmGray mt-1" data-id="element-450">
                  Available 9AM–5PM EST
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}